module.exports = __webpack_public_path__ + "static/img/numberraise3.d99e3d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/numberraise3.png
// module id = Q2N5
// module chunks = 1